import React, { Component } from 'react';
import logo from './logo.svg';
import './Managers.css';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import { PlayerCard } from '../Components/PlayerCard';
import { CustomNav } from '../Components/CustomNav';
import { ContractTable } from '../Components/ContractTable';
import { HenriChart } from '../Components/HenriChart';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import { Line, Pie, Doughnut } from 'react-chartjs-2';
let pitt = require('../Mock/team-management-pit.json');
let jarmo = require('../Mock/gm-jarmo.json');

export class Managers extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    if (!this.state.selectedGM) {
      let e = [];
      e.target = [];
      e.target.value = 'DAL';
      this.changeTeam(e);
    }
  }
  makeLabels(assets) {
    const map1 = Object.keys(assets).map(
      x => this.id2Position[x] + ' - ' + assets[x]
    );
    return map1;
  }
  id2Position = {
    pick: 'Draft Pick',
    c: 'Center',
    nonroster: 'Non-Rostered',
    d: 'Defense',
    g: 'Goalies',
    w: 'Winger'
  };
  changeTeam(e) {
    console.log('changin gm');
    let currentComponent = this;
    let value = e.target.value;
    let url = apiServerUrl + '/gm_info?team=' + e.target.value;
    // Make a request for a user with a given ID
    console.log(url);
    axios
      .get(url, requestOptions())
      .then(function(response) {
        console.log('called out ' + JSON.stringify(response.data));
        let pick = response.data.gm_draft.map(x => x.pick);
        let exp_gm = response.data.gm_draft.map(x => x.exp_gm);
        let gm_gp = response.data.gm_draft.map(x => x.gm_gp);
        console.log('called pick ' + JSON.stringify(pick));
        console.log('called exp_gm ' + JSON.stringify(exp_gm));
        console.log('called gm_gp ' + JSON.stringify(gm_gp));

        console.log(
          'called response.data.relinquished ' +
            JSON.stringify(response.data.relinquished)
        );
        console.log(
          'called response.data.acquired ' +
            JSON.stringify(response.data.acquired)
        );
        currentComponent.setState({
          selectedGM: response.data,
          assetsOut: response.data.relinquished,
          assetsIn: response.data.acquired,
          pick: response.data.gm_draft.map(x => x.pick),
          exp_gm: response.data.gm_draft.map(x => x.exp_gm),
          gm_gp: response.data.gm_draft.map(x => x.gm_gp)
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  render() {
    console.log(this.state.assetsOut);
    var pieLegend = {
      labels: { boxWidth: 20, fontColor: 'white' },
      position: 'left'
    };

    const outData = {
      labels: this.state.assetsOut
        ? this.makeLabels(this.state.assetsOut)
        : null,
      datasets: [
        {
          data: this.state.assetsOut
            ? Object.values(this.state.assetsOut)
            : null,
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#EC932F',
            '#71B37C',
            '#4BC0C0'
          ],
          hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56']
        }
      ]
    };
    const data = {
      labels: this.state.assetsIn ? this.makeLabels(this.state.assetsIn) : null,
      datasets: [
        {
          data: this.state.assetsIn ? Object.values(this.state.assetsIn) : null,
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#EC932F',
            '#71B37C',
            '#4BC0C0'
          ],
          hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56']
        }
      ]
    };
    console.log(this.state.pick);
    console.log(this.state.exp_gm);
    console.log(this.state.gm_gp);
    var legend = { labels: { boxWidth: 20 } };
    var lineChartData = {
      labels: this.state.pick,
      datasets: [
        {
          label: 'Average GM',
          backgroundColor: '#DC143C',
          borderColor: '#DC143C',
          fill: false,
          data: this.state.exp_gm
        },
        {
          label: 'This GM',
          backgroundColor: '#008000',
          borderColor: '#008000',
          fill: false,
          data: this.state.gm_gp
        }
      ]
    };
    return (
      <div>
        <header className="nav">
          <CustomNav />
        </header>
        <div className="managers-flex-grid" style={{ marginTop: '1em' }}>
          <div
            className="managers-hds-container"
            style={{ flexDirection: 'column', border: '1px solid grey' }}
          >
            <div
              className="managers-bio-box gutter-right"
              style={{ margin: 0 }}
            >
              <div className="managers-bio-pic-box" style={{ display: 'flex' }}>
                {this.state.selectedGM && (
                  <img
                    className="managers-bio-pic"
                    src={this.state.selectedGM.gm_photo_url}
                    alt="GM Picture"
                    width="auto"
                    height="100"
                  />
                )}
              </div>
              <div
                className="managers-bio-data-box"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flex: 1,
                  alignContent: 'center',
                  justifyContent: 'space-around'
                }}
              >
                <div>
                  {this.state.selectedGM && (
                    <div
                      className="managers-bio-datum"
                      style={{ flex: 1, textAlign: 'center' }}
                    >
                      Name: {this.state.selectedGM.gm_name}
                    </div>
                  )}
                  {this.state.selectedGM && (
                    <div
                      className="managers-bio-datum"
                      style={{ flex: 1, textAlign: 'center' }}
                    >
                      Team: {this.state.selectedGM.team_name}
                    </div>
                  )}
                  {this.state.selectedGM && (
                    <div
                      className="managers-bio-datum"
                      style={{ flex: 1, textAlign: 'center' }}
                    >
                      Years as GM: {this.state.selectedGM.years_as_gm}
                    </div>
                  )}
                  {this.state.selectedGM && (
                    <div
                      className="managers-bio-datum"
                      style={{ flex: 1, textAlign: 'center' }}
                    >
                      Age: {this.state.selectedGM.age}
                    </div>
                  )}
                </div>

                {/*}<div className="managers-bio-datum" style={{flex: 1, textAlign: 'center'}}>Salary: {this.state.selectedGM.salary}</div>*/}
                <div className="managers-bio-data-box">
                  <select
                    className="teamList"
                    style={{ alignSelf: 'flex-start' }}
                    onChange={e => this.changeTeam(e)}
                  >
                    <option>CHOOSE TEAM</option>
                    <option value="DAL">Dallas Stars</option>
                    <option value="STL">St Louis Blues</option>
                    <option value="NSH">Nashville Predators</option>
                    <option value="CHI">Chicago Blackhawks</option>
                    <option value="WPG">Winnipeg Jets</option>
                    <option value="MIN">Minnesota Wild</option>
                    <option value="L.A">Los Angeles Kings</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="managers-flex-grid" style={{ margin: '1em 0' }}>
          <div
            className="managers-hds-container"
            style={{
              flexDirection: 'column',
              border: '1px solid grey',
              background: '#2f526c'
            }}
          >
            <div
              className="managers-gm-performance gutter-right"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch'
              }}
            >
              <h2 style={{ color: 'white', textAlign: 'center' }}>
                GM Drafting Performance
              </h2>
              <div className="managers-gm-performance-chart-box">
                {this.state.pick && (
                  <Line
                    options={{ maintainAspectRatio: true, responsive: true }}
                    data={lineChartData}
                    legend={legend}
                  />
                )}
              </div>
            </div>
          </div>
          <div
            className="managers-hds-container"
            style={{
              flexDirection: 'column',
              border: '1px solid grey',
              justifyContent: 'center',
              padding: '1em',
              background: '#2f526c'
            }}
          >
            <div
              className="managers-assets-rcvd gutter-right"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                margin: 0
              }}
            >
              <h2 style={{ color: 'white', textAlign: 'center' }}>
                Trade Assets Received
              </h2>
              <div className="managers-assets-rcvd-chart-box">
                {this.state.assetsIn && (
                  <Pie
                    data={data}
                    options={{ maintainAspectRatio: true, responsive: true }}
                    legend={pieLegend}
                  />
                )}
              </div>
            </div>
            <div
              className="managers-assets-sent gutter-right"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                margin: 0
              }}
            >
              <h2 style={{ color: 'white', textAlign: 'center' }}>
                Trade Assets Sent
              </h2>
              <div className="managers-assets-sent-chart-box">
                {this.state.assetsOut && (
                  <Pie
                    data={outData}
                    options={{ maintainAspectRatio: true, responsive: true }}
                    legend={pieLegend}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/*
                <div class="managers-flex-grid" style={{ marginTop: "1em" }}>
                    <div className="managers-hds-container" style={{ flexDirection: "column", border: "1px solid grey" }}>
                        <div className="gutter-right" style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', border: '1px dotted white', backgroundColor: 'white' }}>
                            <h2 style={{ color: 'grey', textAlign: 'center' }}>Recent Trades</h2>
                        </div>
                    </div>
                </div>

                <div class="managers-flex-grid" style={{ marginTop: "1em" }}>
                    <div className="managers-hds-container" style={{ flexDirection: "column", border: "1px solid grey" }}>
                        <div className="gutter-right" style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', border: '1px dotted white', backgroundColor: 'white' }}>
                            <h2 style={{ color: 'grey', textAlign: 'center' }}>Free Agency</h2>
                        </div>
                    </div>
                </div>*/}
      </div>
    );
  }
}

export default Managers;



// WEBPACK FOOTER //
// ./src/Pages/Managers.js